import {combineReducers} from "redux"
import {createPivotTableReducer} from "reducers/pivotTable"
import filters from './filters'

export const quotingContextApprovalsPivotTableKey = 'quotingContext.approvals.pivotTable'

export default combineReducers({
  filters,
  pivotTable: createPivotTableReducer({
    key: quotingContextApprovalsPivotTableKey,
    defaultSortColumn: 'createdDate',
  }),
})
